import { PhotoIcon, UserCircleIcon, EnvelopeIcon } from '@heroicons/react/24/solid'
import { Menu, Transition } from '@headlessui/react'
import DropDown from './Dropdown'
import { useEffect, useState } from 'react';
import { validateRecipient } from '../debtUtilities';
import { validateIdNumber } from '../utilities';
import useCreadyApi from '../utils/Api';

export default function RecipientCreation({ notifyParent, resetTrigger }) {

	const defaultRecipient = { name: "", type: 0, idnumber: "", email: "", phone: "", street: "", zipcode: "", city: "" };
	const api = useCreadyApi();
	const [isLoaded, setIsLoaded] = useState(false);
	const [recipient, setRecipient] = useState(defaultRecipient);
	const [isCompany, setIsCompany] = useState(false);
	const [showPopup, setShowPopup] = useState(false);
	const [validSate, setValidState] = useState([]);
	const [fieldsVisible, setFieldsVisible] = useState(false);
	const [isLookingUp, setIsLookingUp] = useState(false);
	const [showFormatError, setShowFormatError] = useState(false);
	const isIdValid = recipient.idnumber ? validateIdNumber(recipient.idnumber, recipient.type) : false;

	useEffect(() => {
		const savedData = localStorage.getItem('debtCreationData');
		if (savedData) {
			const obj = JSON.parse(savedData);
			const newRecipient = obj.recipient || defaultRecipient;
			setRecipient(newRecipient);
			setIsCompany(newRecipient.type === 1);
			setFieldsVisible(newRecipient.type === 0);
		} else {
			setRecipient(defaultRecipient);
			setIsCompany(false);
			setFieldsVisible(true);
		}
		setShowFormatError(false);
	}, [resetTrigger]);

	function test(value) {
		const company = value.id == 1;
		setIsCompany(company);
		setFieldsVisible(!company);
		setShowFormatError(false);
		if (!company) {
			setRecipient({ name: "", type: value.id, idnumber: "", email: "", phone: "", street: "", zipcode: "", city: "" });
		} else {
			setRecipient({ ...recipient, type: value.id });
		}
	}

	const handleSubmit = (event) => {
		if (!isLoaded) {
			return;
		}
		event.preventDefault();
		if (!fieldsVisible) {
			handleFetch();
			return;
		}
		let v = validateRecipient(recipient);
		setValidState(v);
		if (v.length == 0) {
			afterSubmitFunction();
		}
	};

	const afterSubmitFunction = () => {
		if (!isLoaded) {
			return;
		}
		notifyParent(recipient);
	};

	const resetForm = function () {

		setRecipient({
			name: "", type: 0, idnumber: "", email: "",
			phone: "", street: "", zipcode: "", city: ""
		});

		setShowPopup(false);
	}

	useEffect(() => {
		const savedData = localStorage.getItem('debtCreationData');

		const defaultRecipient = {
			name: "",
			type: 0,
			idnumber: "",
			email: "",
			phone: "",
			street: "",
			zipcode: "",
			city: ""
		};

		if (savedData) {
			const obj = JSON.parse(savedData);
			const loaded = { ...defaultRecipient, ...obj.recipient };
			setRecipient(loaded);
			setIsCompany(loaded.type === 1);
			setFieldsVisible(loaded.type === 0);
		} else {
			setFieldsVisible(true);
		}

		setIsLoaded(true);
	}, []);

	const handleFetch = async () => {
		if (isLookingUp) return;
		if (!isIdValid) {
			setShowFormatError(true);
			return;
		}
		setShowFormatError(false);
		setIsLookingUp(true);
		try {
			if (isCompany) {
				const data = await api.company.lookup(recipient.idnumber);
				if (data) {
					setRecipient(prev => ({
						...prev,
						name: data.foretagsnamn?.trim() || prev.name,
						street: data.postAdress?.trim() || prev.street,
						zipcode: data.postNr?.replace(/\s/g, '') || prev.zipcode,
						city: data.postOrt?.trim() || prev.city,
						phone: data.telefon?.trim() || prev.phone,
						email: data.epost?.trim() || prev.email,
					}));
				}
			}
		} finally {
			setIsLookingUp(false);
			setFieldsVisible(true);
		}
	};
	if (!isLoaded) {
		return <></>
	}
	return (
		<div className="flex flex-row min-h-screen justify-center">
			<div className="mt-4 w-full max-w-[574px]">
				<h3 className="text-2xl font-semibold leading-6 text-gray-900">1. Gäldenär (steg 1/2)</h3>


				<form className="mt-4" id="recipientform" onSubmit={handleSubmit}>
					<div className="py-6">
						<div className="grid w-full max-w-[574px] grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-6">
							<div className="sm:col-span-3">
								<DropDown values={[{ id: 0, name: "Privatperson" }, { id: 1, name: "Företag" }]} notifyParent={test} header="Typ av gäldenär" value={recipient.type}></DropDown>
							</div>
							<div className="sm:col-span-3">
								<label htmlFor="last-name" className="block text-sm font-medium leading-6 text-gray-900">
									{isCompany ? "Organisationsnummer" : "Personnummer"}
								</label>
								<div className="relative mt-2">
									<input
										type="text"
										name="idnumber"
										id="idnumber"
										required={true}
										autoComplete="idnumber"
										className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-black-600 sm:text-sm sm:leading-6"
										onChange={(e) => {
											setRecipient({
												...recipient,
												idnumber: e.target.value
											});
											if (isCompany) setFieldsVisible(false);
											setShowFormatError(false);
										}}
										value={recipient.idnumber}
									/>
									{isCompany && showFormatError && (
										<span className="absolute left-0 top-full mt-1 text-sm" style={{ color: '#DB162F' }}>Ogiltigt nummer</span>
									)}
								</div>
								{validSate.filter(v => v.id === "idnumber").map((m) => {
									return <span style={{ color: '#DB162F' }}>{m.message}</span>
								})}
							</div>
							{isCompany && (
								<div className="sm:col-span-3 sm:col-start-1 flex items-center">
									<button
										type="button"
										disabled={isLookingUp}
										onClick={handleFetch}
										className="inline-flex items-center gap-1.5 px-4 py-1.5 text-sm font-semibold text-white bg-blue-1 border-2 border-blue-1 rounded-md shadow-sm cursor-pointer hover:bg-transparent hover:text-blue-1 transition-all duration-100 ease-in-out disabled:opacity-50 disabled:cursor-not-allowed"
									>
										{isLookingUp && (
											<svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
												<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
												<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
											</svg>
										)}
										Hämta
									</button>
								</div>
							)}
							{fieldsVisible && (
								<>
								<div className="sm:col-span-3 sm:col-start-1">
										<label htmlFor="first-name" className="block text-sm font-medium leading-6 text-gray-900">
											Namn
										</label>
										<div className="mt-2">
											<input
												type="text"
												name="name"
												id="name"
												autoComplete="name"
												required={true}
												className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-black-600 sm:text-sm sm:leading-6"
												onChange={(e) => {
													setRecipient({
														...recipient,
														name: e.target.value
													});
												}}
												value={recipient.name}
											/>
										</div>
									</div>
									<div className="sm:col-span-3">
										<label htmlFor="E-post" className="block text-sm font-medium leading-6 text-gray-900">
											E-post
										</label>
										<div className="relative mt-2 rounded-md shadow-sm">
											<div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
												<EnvelopeIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
											</div>
											<input
												type="email"
												name="E-post"
												id="E-post"
												required={false}
												className="block w-full rounded-md border-0 py-1.5 pl-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-black-600 sm:text-sm sm:leading-6"
												placeholder="you@example.com"
												onChange={(e) => {
													setRecipient({
														...recipient,
														email: e.target.value
													});
												}}
												value={recipient.email}
											/>
										</div>
									</div>
									<div className="sm:col-span-3">
										<label htmlFor="phone-number" className="block text-sm font-medium leading-6 text-gray-900">
											Telefon
										</label>
										<div className="relative mt-2 rounded-md shadow-sm">
											<div className="absolute inset-y-0 left-0 flex items-center">
												<label htmlFor="country" className="sr-only">
													Land
												</label>
												<select
													disabled={true}
													id="phone-code"
													name="phone-code"
													required={true}
													autoComplete="phone-code"
													className="h-full rounded-md border-0 bg-transparent py-0 pl-3 pr-7 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-black-600 sm:text-sm"
												>
													<option>SE</option>
												</select>
											</div>
											<input
												type="text"
												name="phone-number"
												id="phone-number"
												required={false}
												className="block w-full rounded-md border-0 py-1.5 pl-16 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-black-600 sm:text-sm sm:leading-6"
												placeholder="+46 123 456 78"
												onChange={(e) => {
													setRecipient({
														...recipient,
														phone: e.target.value
													});
												}}
												value={recipient.phone}
											/>
										</div>
									</div>
									<div className="col-span-full">
										<label htmlFor="street-address" className="block text-sm font-medium leading-6 text-gray-900">
											Adress
										</label>
										<div className="mt-2">
											<input
												type="text"
												name="street-address"
												id="street-address"
												required={true}
												autoComplete="street-address"
												className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-black-600 sm:text-sm sm:leading-6"
												onChange={(e) => {
													setRecipient({
														...recipient,
														street: e.target.value
													});
												}}
												value={recipient.street}
											/>
										</div>
									</div>
									<div className="sm:col-span-3 sm:col-start-1">
										<label htmlFor="city" className="block text-sm font-medium leading-6 text-gray-900">
											Postnummer
										</label>
										<div className="mt-2">
											<input
												type="text"
												name="zipcode"
												id="zipcode"
												required={true}
												autoComplete="postal-code"
												className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-black-600 sm:text-sm sm:leading-6"
												onChange={(e) => {
													setRecipient({
														...recipient,
														zipcode: e.target.value
													});
												}}
												value={recipient.zipcode}
											/>
										</div>
										{validSate.filter(v => v.id === "zipcode").map((m) => {
											return <span style={{ color: '#DB162F' }}>{m.message}</span>
										})}
									</div>
									<div className="sm:col-span-3">
										<label htmlFor="region" className="block text-sm font-medium leading-6 text-gray-900">
											Ort
										</label>
										<div className="mt-2">
											<input
												type="text"
												name="city"
												id="city"
												required={true}
												autoComplete="address-level1"
												className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-black-600 sm:text-sm sm:leading-6"
												onChange={(e) => {
													setRecipient({
														...recipient,
														city: e.target.value
													});
												}}
												value={recipient.city}
											/>
										</div>
									</div>
								</>
							)}
						</div>
					</div>
					{fieldsVisible && (
						<div className="flex items-center justify-end gap-x-6 py-4">
							<button
								onClick={() => setShowPopup(true)}
								type="button"
								className="px-6 py-2.5 text-sm font-semibold text-center text-red hover:bg-red bg-transparent border-2 border-red rounded-md cursor-pointer hover:text-white shadow-sm transition-all duration-100 ease-in-out">
								Avbryt
							</button>

							<button
								type="submit"
								className="px-8 py-2.5 text-sm font-semibold text-white bg-blue-1 border-2 border-blue-1 rounded-md shadow-sm cursor-pointer hover:bg-transparent hover:text-blue-1 transition-all duration-100 ease-in-out">
								Nästa
							</button>
						</div>
					)}
				</form>
			</div>

			{/* Popup */}
			{showPopup && (
				<div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
					<div className="bg-white rounded-lg shadow-xl max-w-sm w-full px-4 pb-4 pt-4 ">
						<h3 className="text-lg font-semibold mb-4 mt-3">
							Avbryt registrering av inkassoärendet
						</h3>
						<p className="text-gray-900 mb-4">
							Är du säker på att du vill avbryta registreringen av inkassoärendet?
						</p>

						<div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
							<button
								className="inline-flex items-center mt-1 justify-center pl-2 pr-4 py-2.5 mb-4 text-m font-semibold text-center hover:text-red bg-red align-middle transition-all duration-100 ease-in-out hover:bg-transparent border-2 border-red border-solid rounded-md cursor-pointer text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-1"
								onClick={() => {
								const currentType = recipient.type;
								setRecipient({ ...defaultRecipient, type: currentType });
								setShowPopup(false);
								setShowFormatError(false);
								setIsCompany(currentType === 1);
								setFieldsVisible(currentType === 0);
							}}
							>
								Ja, avbryt
							</button>
							<button
								className="inline-flex mt-1 block px-6 py-2.5 mb-4 text-m font-semibold text-center text-blue-2 hover:bg-blue-2 align-middle transition-all duration-100 ease-in-out bg-transparent border-2 border-blue-2 border-solid rounded-md cursor-pointer hover:text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-1"
								onClick={() => setShowPopup(false)}
							>
								Nej, fortsätt registrering
							</button>
						</div>
					</div>
				</div>
			)}
		</div>
	)
}
